export { GeneralTerms } from './general-terms.component';
export { PerchGeneralTermsAndConsent } from './perch-general-terms.component';
